import React from 'react';

function InstructorHelpModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex', justifyContent: 'center',
      alignItems: 'center', zIndex: 2000, padding: '20px'
    }}>
      <div style={{
        background: '#ffffff', padding: '30px', borderRadius: '16px', maxWidth: '650px',
        width: '100%', maxHeight: '85vh', overflowY: 'auto', boxShadow: '0 20px 25px rgba(0,0,0,0.1)'
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h2 style={{ fontSize: '1.5rem', fontWeight: '800', color: '#1e293b' }}>📖 Instructor Guide & Help</h2>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer', color: '#64748b' }}>&times;</button>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', color: '#475569', fontSize: '0.95rem', lineHeight: '1.6' }}>
          <div>
            <h3 style={{ color: '#0f172a', fontSize: '1.1rem', fontWeight: '700', marginBottom: '4px' }}>1️⃣ Profile Settings & Password</h3>
            <p>Click on <strong>Profile Settings</strong> in the top right corner to check or update your personal details and password.</p>
          </div>

          <div>
            <h3 style={{ color: '#0f172a', fontSize: '1.1rem', fontWeight: '700', marginBottom: '4px' }}>2️⃣ Calendar Working Hours, Blocking & Cancellation Notice</h3>
            <p>At the top of your dashboard calendar, set your weekly <strong>Working Hours</strong> (Start and End times) and your <strong>Cancellation Notice</strong> window and always click <strong>Save Grid Changes</strong>. Click calendar slots to block out time or assign lessons,</p>
          </div>

          <div>
            <h3 style={{ color: '#0f172a', fontSize: '1.1rem', fontWeight: '700', marginBottom: '4px' }}>3️⃣ Adding New Students</h3>
            <p>Scroll down to the bottom of your dashboard and use the <strong>Add New Student</strong> form. Enter their name and email to register them (this automatically sends a secure account setup link straight to their inbox).</p>
          </div>

          <div>
            <h3 style={{ color: '#0f172a', fontSize: '1.1rem', fontWeight: '700', marginBottom: '4px' }}>4️⃣ Managing Students, Direct Messages & Reports</h3>
            <p>Your active students are listed at the bottom where you can click to view details, track progress milestones, and <strong>print individual student progress/lesson reports</strong> from their logs. You can also send <strong>direct messages</strong> to specific students.</p>
          </div>

          <div>
            <h3 style={{ color: '#0f172a', fontSize: '1.1rem', fontWeight: '700', marginBottom: '4px' }}>5️⃣ Broadcast Announcements & Summary Reports</h3>
            <p>Use the <strong>Broadcast Announcement</strong> box on the right to notify your entire roster at once. Use the <strong>Print All Students Report</strong> button at the top right for a quick summary of your whole school.</p>
          </div>
        </div>

        <div style={{ marginTop: '30px', textAlign: 'right' }}>
          <button onClick={onClose} style={{ padding: '10px 20px', backgroundColor: '#0066cc', color: '#fff', border: 'none', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer' }}>
            Got It, Thanks!
          </button>
        </div>
      </div>
    </div>
  );
}

export default InstructorHelpModal;